import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Typography, Box, Divider } from "@mui/material";

export default function CustomCard(props) {
  const { headers,rightData,note, customTab, showDivider = true } = props; // Default showDivider to true

  return (
    <Box>
      <Card sx={{ margin: "15px 0px" }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginBottom={1}
          >
            <Box display="flex" alignItems="center">
              <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                {headers}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
                {rightData}
            </Box>
          </Box>
          {note && (
            <Box display="flex" alignItems="center">
              <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                <strong>Note:</strong> {note}
              </Typography>
            </Box>
          )}
          {showDivider && <Divider sx={{ my: '15px' }} />} {/* Conditionally render Divider */}
          {customTab}
        </CardContent>
      </Card>
    </Box>
  );
}
